import React from 'react'
import { shape, string } from 'prop-types'
import './index.scss'
import FooterItem from './footer-item'

const GlobalFooter = ({
  moduleData: { Section: section }, name, type, moduleId,
}) => (
  <React.Fragment>
    <div
      className="footer-wrapper"
      data-module={name}
      data-module-name={name}
      data-module-id={moduleId}
      data-module-type={type}
    >
      <div className="global-footer-wrapper" data-testid="global-footer">
        <div className="global-footer-wrapper-links">
          {section.map(subSection => (
            <div className="global-footer-inner-wrapper" key={subSection.uid}>
              <FooterItem subSection={subSection} />
            </div>
          ))}
          <div className="cookies-settings-strip">
            <button type="button" id="ot-sdk-btn" className="optanon-toggle-display">
              Cookie Settings
            </button>
          </div>
        </div>
      </div>
    </div>
  </React.Fragment>
)

GlobalFooter.propTypes = {
  moduleData: shape({}).isRequired,
  name: string,
  moduleId: string,
  type: string,
}

GlobalFooter.defaultProps = {
  name: null,
  moduleId: null,
  type: null,
}

export default GlobalFooter



// WEBPACK FOOTER //
// ./components/cms/components/footer-global/index.js